import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from 'reactstrap';
import firebase from 'firebase';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
// import { makeStyles } from '@mui/material/styles';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import algoliasearch from 'algoliasearch/lite';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys';
import format from 'date-fns/format';
import { useRef } from 'react';

// const useStyles = makeStyles({
//   listbox: {
//     background: '#27293d',
//   },
//   input: {
//     borderColor: '#2b3553',
//     fontSize: '0.85rem',
//     color: 'whitesmoke',
//     borderRadius: '0.4285rem',
//     padding: '10px 18px 10px 18px',
//   },
//   inputRoot: {
//     padding: '0px 0px 5px 0px !important',
//   },
// });

function SpecialDiscountModal({
  notify,
  setModal,
  id,
  getStudent,
  setSpecialData,
  currentSpecialData,
  setStudentData,
  studentData,
  edit,
  studentSearch,
}) {
  const [error, setError] = useState('');
  const {
    register,
    handleSubmit,
    control,
    getValues,
    formState: { errors },
  } = useForm();
  
  // const [stuID, setStuID] = useState("");
  // const [stuName, setStuName] = useState("");
  const [fromDate, setFromDate] = useState('');
  const stuID = useRef('');
  const stuName = useRef('');
  const classes = {
    listbox: {
      background: '#27293d',
    },
    input: {
      borderColor: '#2b3553',
      fontSize: '0.85rem',
      color: 'whitesmoke',
      borderRadius: '0.4285rem',
      padding: '10px 18px 10px 18px',
    },
    inputRoot: {
      padding: '0px 0px 5px 0px !important',
    },
  };

  const onSubmit = (data) => {
    let res;
    console.log('id:', stuID.current);
    if (stuID.current === '' || !stuID.current)
      return notify('Something went wrong, Please select student again', true);
    if (currentSpecialData) {
      res = db.collection('DiscountCoupons').doc(currentSpecialData.itemID);
    } else {
      res = db.collection('DiscountCoupons').doc();
    }

    let finalData = {};

    if (currentSpecialData) {
      finalData = {
        itemID: res.id,
        couponCode: data.couponCode,
        discountType: data.DiscountType,
        discountAmount: parseFloat(data.discountAmount),
        discountIn: data.discountIn,
        validFrom: data.validFrom,
        validTill: data.validTill,
        visibility: '',
        // remarks: data.remarks,
        couponFor: {
          stuID: stuID.current,
          stuName: stuName.current,
        },
        used: false,
        lastUpdated: firebase.firestore.FieldValue.serverTimestamp(),
        createdOn: firebase.firestore.FieldValue.serverTimestamp(),
        type: 'Special',
      };
    } else {
      finalData = {
        itemID: res.id,
        couponCode: data.couponCode,
        discountType: data.DiscountType,
        discountAmount: parseFloat(data.discountAmount),
        discountIn: data.discountIn,
        validFrom: data.validFrom,
        validTill: data.validTill,
        visibility: '',
        // remarks: data.remarks,
        couponFor: {
          stuID: stuID.current,
          stuName: stuName.current,
        },
        used: false,
        createdOn: firebase.firestore.FieldValue.serverTimestamp(),
        type: 'Special',
      };
    }

    console.log('finalData', finalData);
    res
      .set(finalData)
      .then((res) => {
        if (currentSpecialData) {
          notify('Coupon Updated Successfuly', false);
        } else {
          notify('Coupon Created Successfuly', false);
        }

        if (currentSpecialData) {
          setSpecialData((prev) =>
            prev.map((item) =>
              item.itemID == currentSpecialData.itemID ? { ...finalData } : item
            )
          );
        } else {
          setSpecialData((prev) => [finalData, ...prev]);
        }
        setModal();
      })
      .catch((err) => {
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  React.useEffect(() => {
    if (
      currentSpecialData &&
      currentSpecialData.couponFor &&
      currentSpecialData?.couponFor?.stuID.current
    ) {
      console.log('id', currentSpecialData?.couponFor?.stuID.current);
      db.collection('zSystemStudents')
        .where('_uniqueID', '==', currentSpecialData?.couponFor?.stuID.current)
        .get()
        .then((query) => {
          let data = query.docs.map((doc) => doc.data());
          console.log('data', data, studentData);
          setStudentData((prev) => {
            console.log('prev', [...prev, ...data]);
            return prev;
          });
        });
    }
    if (currentSpecialData?.couponFor?.stuID){
    let  selectedStudent = studentData.find(
        (student) => student._uniqueID === currentSpecialData?.couponFor?.stuID
      )
      stuID.current = selectedStudent._uniqueID;
      stuName.current = `${selectedStudent.firstname} ${selectedStudent.lastname}`;

    }
  }, [currentSpecialData]);

  return (
    <>
      <div className='content' style={{ width: 1150 }}>
        <Row>
          <Col md='8'>
            <Card style={{ border: '2px solid white' }}>
              <CardHeader>
                {currentSpecialData ? (
                  <h5 className='title'>Edit Special Code</h5>
                ) : (
                  <h5 className='title'>Add Special Code</h5>
                )}
              </CardHeader>
              <CardBody>
                <Form
                  style={{ paddingRight: 10 }}
                  onSubmit={handleSubmit(onSubmit)}
                  autoComplete='off'
                >
                  <Row>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>Coupon Code</label>
                        <input
                         className='form-control'
                          {...register('couponCode', {
                            required: true,
                            maxLength: 10,
                            minLength: 10,
                            pattern: {
                              value: /^(?=.*[A-Za-z])[A-Za-z\d@$!%*#?&]{8,}$/,
                              message: 'Invalid coupon code',
                            },
                          })}
                          defaultValue={
                            currentSpecialData
                              ? `${currentSpecialData.couponCode}`
                              : `SPE${id.toUpperCase()}`
                          }
                          placeholder='Coupon Code'
                          type='text'
                          style={{ marginBottom: 0 }}
                        />
                        {console.log(errors,"errors")}
                        {errors.couponCode &&
                          errors.couponCode.type === 'required' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              This field is required
                            </span>
                          )}
                        {errors.couponCode &&
                          errors.couponCode.type === 'minLength' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              Minimum length for couponcode is 10
                            </span>
                          )}
                        {errors.couponCode &&
                          errors.couponCode.type === 'maxLength' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              Maximum length for couponcode is 10
                            </span>
                          )}
                        {errors.couponCode &&
                          errors.couponCode.type === 'pattern' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              Please enter valid code
                            </span>
                          )}
                      </FormGroup>
                    </Col>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>Type</label>

                        <select
                          {...register('DiscountType', { required: true })}
                          defaultValue={
                            currentSpecialData && currentSpecialData.discountType
                          }
                          type='select'
                          style={{ marginBottom: 0 }}
                          className='form-control'
                        >

                          <option value=''>Select type of discount</option>
                          <option value='disability'>Disability</option>
                          <option value='sibling'>Sibling</option>
                          <option value='oldStudent'>Old Student</option>
                          <option value='Other'>Other</option>
                        </select>
                        {errors.DiscountType &&
                          errors.DiscountType.type === 'required' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              This field is required
                            </span>
                          )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>Valid From</label>
                        <input
                        className='form-control'
                          {...register('validFrom', { required: true })}
                          defaultValue={
                            currentSpecialData && currentSpecialData.validFrom
                          }
                          placeholder='Valid From'
                          type='datetime-local'
                          style={{ marginBottom: 0 }}
                          onChange={(e) => setFromDate(e.target.value)}
                          min={
                            edit ? format(new Date(), "yyyy-MM-dd'T'00:00") : ''
                          }
                        />

                        {errors.validFrom &&
                          errors.validFrom.type === 'required' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              This field is required
                            </span>
                          )}
                      </FormGroup>
                    </Col>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>Students</label>
                        {console.log(currentSpecialData,"currentSpecialData")}
                        <select
                          {...register('studentDetails', { required: true })}
                          defaultValue={
                            currentSpecialData?.couponFor?.stuID || '' 
                          }
                          style={{ width: 340, marginBottom: 0 }}
                          className="form-control"
                          onChange={(e) => {
                            const selectedID = e.target.value;
                            const selectedStudent = studentData.find(
                              (student) => student._uniqueID === selectedID
                            );
                            if (selectedStudent) {
                              stuID.current = selectedStudent._uniqueID;
                              stuName.current = `${selectedStudent.firstname} ${selectedStudent.lastname}`;
                            } else {
                              stuID.current = null;
                              stuName.current = '';
                            }
                          }}
                        >
                          <option value="">Select Student</option>
                          {studentData.map((student) => (
                            <option key={student._uniqueID} value={student._uniqueID}>
                              {`${student.firstname} ${student.lastname}${student.enrollmentNO ? ` -> ${student.enrollmentNO}` : ''}`}
                            </option>
                          ))}
                        </select>

                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>Discount Of</label>
                        <Row>
                          <Col md='4'>
                            <select
                              className='form-control'
                              {...register('discountIn', { required: true })}
                              defaultValue={
                                currentSpecialData && currentSpecialData.discountIn
                              }
                              type='select'
                              style={{ paddingLeft: 9, marginBottom: 0 }}
                            >
                              <option value="Rupees">Rupees</option>
                              <option value="Percentage">Percent</option>
                            </select>
                            {errors.discountIn &&
                              errors.discountIn.type === 'required' && (
                                <span style={{ fontSize: 12, color: 'red' }}>
                                  This field is required
                                </span>
                              )}
                          </Col>
                          <Col md='8'>
                            <Controller
                              name="discountAmount"
                              control={control}
                              rules={{ required: true }}
                              defaultValue={currentSpecialData.discountAmount}
                              render={({ field }) => (
                                <input
                                type="number"
                                className="form-control"
                                placeholder="Discount OF"
                                value={field.value ||''}
                                onChange={(e) => {
                                    { console.log(field)}
                                    const value = parseFloat(e.target.value || '0');
                                    const discountType = getValues('discountIn');

                                    if (discountType === 'Percentage') {
                                      if (value <= 100) field.onChange(value);
                                    } else {
                                      field.onChange(value);
                                    }
                                  }}
                                  style={{ marginBottom: 0 }}
                                />
                              )}
                            />


                            {errors.discountAmount &&
                              errors.discountAmount.type === 'required' && (
                                <span style={{ fontSize: 12, color: 'red' }}>
                                  This field is required
                                </span>
                              )}
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                    {/* <Col>
                      <FormGroup>
                        <label>Remarks</label>
                        <Input
                          defaultValue={currentSpecialData && currentSpecialData.remarks}
                          innerRef={register({ required: false })}
                          name="remarks"
                          placeholder="Remarks"
                          type="textarea"
                          style={{marginBottom:0}}
                        />
                      </FormGroup>
                    </Col> */}
                  </Row>
                  <Row style={{ display: 'none' }}>
                    <Col className='pr-md-1' md='6'>
                      <FormGroup>
                        <label>Valid Till</label>
                        <input
                        className='form-control'
                          {...register('validTill', { required: true })}
                          defaultValue={format(
                            new Date('1 1 2080'),
                            "yyyy-MM-dd'T'HH:mm"
                          )}
                          placeholder="Valid Till"
                          type="datetime-local"
                          style={{ marginBottom: 0 }}
                        />

                        {errors.validTill &&
                          errors.validTill.type === 'required' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              This field is required
                            </span>
                          )}
                        {errors.validTill &&
                          errors.validTill.type === 'min' && (
                            <span style={{ fontSize: 12, color: 'red' }}>
                              End datetime should be greater than from datetime
                            </span>
                          )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <br></br>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Button color='info' type='submit'>
                      Submit
                    </Button>
                    <Button onClick={() => setModal(false)}>Back</Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default SpecialDiscountModal;
